import { useNavigate } from "react-router-dom";
import Time from "../Time/Time";
import classes from "./Navbar.module.scss";

export default function Navbar() {
  let navigate = useNavigate();

  return (
    <header className={classes.header}>
      <div className={classes.logo} onClick={() => navigate("")}>
        {"CommunityFactories®"}
      </div>
      <Time className={classes.time} />
      <div></div>
    </header>
  );
}
